import { isEmpty, has, keys } from 'lodash';
import { produce } from 'immer';
import { ACTIONS } from '../actions/database.actions';

export const initialState = {
    // CRM DB
    alternativeAttributes: {},

    regions: {},

    destinations: {},
    destinationPictures: {},

    hotels: {},
    hotelPictures: {},
    hotelPromotions: {},
    hotelRooms: {},

    // Local DB
    hotelReviews: {},
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    return produce(state, (draft) =>
    {
        switch (action.type)
        {
            case ACTIONS.DELETE:
                if (has(draft, `${action.payload.key}.${action.payload.id}`))
                {
                    delete draft[action.payload.key][action.payload.id];
                }
                break;
            case ACTIONS.PUT:
                keys(draft).forEach((key) =>
                {
                    if (has(action, `payload.database.${key}`)) draft[key] = { ...draft[key], ...action.payload.database[key] };
                });
                break;
            default:
                break;
        }
    });
}
